import { get, values } from 'lodash';
import {
  FETCH_IN_OUT_ORDER_TRANS,
  FETCH_IN_OUT_ORDER_TRANS_FAILED,
  FETCH_IN_OUT_ORDER_TRANS_SUCCEED,
  FETCH_IN_OUT_TRANS,
  FETCH_IN_OUT_TRANS_EXTERNAL,
  FETCH_IN_OUT_TRANS_EXTERNAL_FAILED,
  FETCH_IN_OUT_TRANS_EXTERNAL_SUCCEED,
  FETCH_IN_OUT_TRANS_FAILED,
  FETCH_IN_OUT_TRANS_SUCCEED,
  FETCH_WALLET_BALANCE,
  FETCH_WALLET_BALANCE_FAILED,
  FETCH_WALLET_BALANCE_SUCCEED,
  FETCH_TRANS,
  FETCH_TRANS_SUCCEED,
  FETCH_TRANS_FAILED,
  FETCH_EXT_TRANS,
  FETCH_EXT_TRANS_SUCCEED,
  FETCH_EXT_TRANS_FAILED,
  FETCH_ORDER_TRANS,
  FETCH_ORDER_TRANS_SUCCEED,
  FETCH_ORDER_TRANS_FAILED,
  FETCH_IN_OUT_ORDER_TRANS_CHART,
  FETCH_IN_OUT_ORDER_TRANS_CHART_SUCCEED,
  FETCH_IN_OUT_ORDER_TRANS_CHART_FAILED,
  FETCH_IN_OUT_TRANS_CHART,
  FETCH_IN_OUT_TRANS_CHART_SUCCEED,
  FETCH_IN_OUT_TRANS_CHART_FAILED,
  FETCH_IN_OUT_TRANS_EXTERNAL_CHART,
  FETCH_IN_OUT_TRANS_EXTERNAL_CHART_SUCCEED,
  FETCH_IN_OUT_TRANS_EXTERNAL_CHART_FAILED,
} from '../actions/statistic/action_types';

const statisticDate = {};

export default (
  state = {
    inOutOrderTrans: [],
    inOutTrans: [],
    inOutTransExternal: [],
    walletBalance: [],
    statisticDate: {},
    trans: [],
    extTrans: [],
    orderTrans: {},
    inOutOrderTransChart: [],
    inOutTransChart: [],
    inOutTransExternalChart: {},
  }, action,
) => {
  switch (action.type) {
    case FETCH_IN_OUT_ORDER_TRANS:
      return {
        ...state,
      };
    case FETCH_IN_OUT_ORDER_TRANS_SUCCEED:
      const mapOrderTrans = {};

      window._.forOwn(action.params, (value, key) => {
        if (value) {
          statisticDate.begin = value.begin;
          statisticDate.end = value.end;

          if (!mapOrderTrans[`${value.coin}:${value.currency}`]) {
            mapOrderTrans[`${value.coin}:${value.currency}`] = value;
            mapOrderTrans[`${value.coin}:${value.currency}`].market = `${value.coin} / ${value.currency}`;
            mapOrderTrans[`${value.coin}:${value.currency}`].key = `${value.coin} / ${value.currency}`;
          }

          if (`${value.coin}:${value.currency}:Buy` === key) {
            mapOrderTrans[`${value.coin}:${value.currency}`].total_amount_buy = value.total_amount;
            mapOrderTrans[`${value.coin}:${value.currency}`].total_fee_buy = value.total_fee;
            mapOrderTrans[`${value.coin}:${value.currency}`].totalCount = get(mapOrderTrans[`${value.coin}:${value.currency}`], 'totalCount', 0) + value.count;
          } else {
            mapOrderTrans[`${value.coin}:${value.currency}`].total_amount_sell = value.total_amount;
            mapOrderTrans[`${value.coin}:${value.currency}`].total_fee_sell = value.total_fee;
            mapOrderTrans[`${value.coin}:${value.currency}`].totalCount = get(mapOrderTrans[`${value.coin}:${value.currency}`], 'totalCount', 0) + value.count;
          }
        }
      });
      return {
        ...state,
        inOutOrderTrans: values(mapOrderTrans),
        statisticDate,
      };

    case FETCH_IN_OUT_ORDER_TRANS_FAILED:
      return {
        ...state,
      };

    case FETCH_IN_OUT_TRANS:
      return {
        ...state,
      };

    case FETCH_IN_OUT_TRANS_SUCCEED:
      const mapTrans = {};

      window._.forOwn(action.params, (value, key) => {
        if (value) {
          if (!mapTrans[`${value.coin}`]) {
            mapTrans[`${value.coin}`] = value;
            mapTrans[`${value.coin}`].market = `${value.coin}`;
            mapTrans[`${value.coin}`].key = `${value.coin}`;
          }

          if (`${value.coin}:Deposit` === key) {
            mapTrans[`${value.coin}`].total_amount_deposit = value.total_amount;
            mapTrans[`${value.coin}`].total_fee_deposit = value.total_fee;
            mapTrans[`${value.coin}`].totalCount = get(mapTrans[`${value.coin}`], 'totalCount', 0) + value.count;
          } else {
            mapTrans[`${value.coin}`].total_amount_withdraw = value.total_amount;
            mapTrans[`${value.coin}`].total_fee_withdraw = value.total_fee;
            mapTrans[`${value.coin}`].totalCount = get(mapTrans[`${value.coin}`], 'totalCount', 0) + value.count;
          }

          statisticDate.begin = value.begin;
          statisticDate.end = value.end;
        } else {
          const coinType = `${key}`.split(':');
          const coin = coinType[0];
          const typeTrans = coinType[1];

          if (!mapTrans[coin]) {
            mapTrans[coin] = {};
            mapTrans[coin].market = `${coin}`;
          }

          if (typeTrans === 'Deposit') {
            mapTrans[coin].total_amount_deposit = 0;
            mapTrans[coin].total_fee_deposit = 0;
            mapTrans[coin].totalCount = 0;
          } else {
            mapTrans[coin].total_amount_withdraw = 0;
            mapTrans[coin].total_fee_withdraw = 0;
            mapTrans[coin].totalCount = 0;
          }
        }
      });

      return {
        ...state,
        inOutTrans: values(mapTrans),
        statisticDate,
      };

    case FETCH_IN_OUT_TRANS_FAILED:
      return {
        state,
      };

    case FETCH_IN_OUT_TRANS_EXTERNAL:
      return {
        ...state,
      };

    case FETCH_IN_OUT_TRANS_EXTERNAL_SUCCEED:
      const mapTransExt = {};

      window._.forOwn(action.params, (value, key) => {
        if (value) {
          if (!mapTransExt[`${value.coin}`]) {
            mapTransExt[`${value.coin}`] = value;
            mapTransExt[`${value.coin}`].market = `${value.coin}`;
            mapTransExt[`${value.coin}`].key = `${value.coin}`;
          }

          if (`${value.coin}:Deposit` === key) {
            mapTransExt[`${value.coin}`].total_amount_deposit = value.total_amount;
            mapTransExt[`${value.coin}`].total_fee_deposit = value.total_fee;
            mapTransExt[`${value.coin}`].totalCount = get(mapTransExt[`${value.coin}`], 'totalCount', 0) + value.count;
          } else {
            mapTransExt[`${value.coin}`].total_amount_withdraw = value.total_amount;
            mapTransExt[`${value.coin}`].total_fee_withdraw = value.total_fee;
            mapTransExt[`${value.coin}`].totalCount = get(mapTransExt[`${value.coin}`], 'totalCount', 0) + value.count;
          }

          statisticDate.begin = value.begin;
          statisticDate.end = value.end;
        } else {
          const coinType = `${key}`.split(':');
          const coin = coinType[0];
          const typeTrans = coinType[1];

          if (!mapTransExt[coin]) {
            mapTransExt[coin] = {};
            mapTransExt[coin].market = `${coin}`;
          }

          if (typeTrans === 'Deposit') {
            mapTransExt[coin].total_amount_deposit = 0;
            mapTransExt[coin].total_fee_deposit = 0;
          } else {
            mapTransExt[coin].total_amount_withdraw = 0;
            mapTransExt[coin].total_fee_withdraw = 0;
          }
        }
      });

      return {
        ...state,
        inOutTransExternal: values(mapTransExt),
        statisticDate,
      };

    case FETCH_IN_OUT_TRANS_EXTERNAL_FAILED:
      return {
        ...state,
      };

    case FETCH_WALLET_BALANCE:
      return {
        ...state,
      };

    case FETCH_WALLET_BALANCE_SUCCEED:
      let arr4 = [];
      arr4 = Object.entries(action.params).map(([coin, balance]) => ({ coin, balance }));
      return {
        ...state,
        walletBalance: Object.entries(action.params).map(([coin, balance]) => ({ coin, balance })),
      };

    case FETCH_WALLET_BALANCE_FAILED:
      return {
        ...state,
      };

    case FETCH_TRANS:
      return {
        ...state,
      };

    case FETCH_TRANS_SUCCEED:
      return {
        ...state,
        trans: action.params,
      };

    case FETCH_TRANS_FAILED:
      return {
        ...state,
      };

    case FETCH_EXT_TRANS:
      return {
        ...state,
      };

    case FETCH_EXT_TRANS_SUCCEED:
      return {
        ...state,
        extTrans: action.params,
      };

    case FETCH_EXT_TRANS_FAILED:
      return {
        ...state,
      };
    case FETCH_ORDER_TRANS:
      return {
        ...state,
      };

    case FETCH_ORDER_TRANS_SUCCEED:
      const temp = { ...state.orderTrans };
      temp[action.params.market] = action.params.data;
      return {
        ...state,
        orderTrans: temp,
      };

    case FETCH_ORDER_TRANS_FAILED:
      return {
        ...state,
      };

    case FETCH_IN_OUT_ORDER_TRANS_CHART:
      return {
        ...state,
      };
    case FETCH_IN_OUT_ORDER_TRANS_CHART_SUCCEED:
      return {
        ...state,
        inOutOrderTransChart: action.params,
      };
    case FETCH_IN_OUT_ORDER_TRANS_CHART_FAILED:
      return {
        ...state,
      };
    case FETCH_IN_OUT_TRANS_CHART:
      return {
        ...state,
      };
    case FETCH_IN_OUT_TRANS_CHART_SUCCEED:
      return {
        ...state,
        inOutTransChart: action.params,
      };
    case FETCH_IN_OUT_TRANS_CHART_FAILED:
      return {
        ...state,
      };
    case FETCH_IN_OUT_TRANS_EXTERNAL_CHART:
      return {
        ...state,
      };
    case FETCH_IN_OUT_TRANS_EXTERNAL_CHART_SUCCEED:
      return {
        ...state,
        inOutTransExternalChart: action.params,
      };
    case FETCH_IN_OUT_TRANS_EXTERNAL_CHART_FAILED:
      return {
        ...state,
      };
    default:
      return {
        ...state,
      };
  }
};
